import { render, staticRenderFns } from "./AudiometryApppointmentTable.vue?vue&type=template&id=74785c5c&"
import script from "./AudiometryApppointmentTable.vue?vue&type=script&lang=js&"
export * from "./AudiometryApppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports